export default __webpack_public_path__ + "static/media/102509_060.a88fa955.jpg";